export default __webpack_public_path__ + "static/media/KevanCheftel.f69db306.png";